"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_1.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1. Les 500 preguntes de Cultura General més repetides als exàmens de Policia Local
    {
        id: 1,
        tax: 0.04,
        created_at: "2022-03-10 00:00:06",
        start_at: "2022-03-10 00:00:06",
        sku: "iopos.book.metodoa",
        title: "Les 500 preguntes de Cultura General més repetides als exàmens de Policia Local",
        description: "Una forma distinta de encarar la prueba de cultura general de las oposiciones a Policía Local.",
        name: "Método A",
        enabled: false,
        stock: false,
        stock_message: "¡Temporalmente sin estoc!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        price: 34.99,
        // offer: 34.99,
        // offer_text: "Oferta 25% Sant Jordi 2024!",
        images: ["/1/image0"],
        banner: ["/1/banner"],
        shipment: 4.49,
        link: "/tienda/libros/metodo-a-las-500-preguntas-mas-repetidas-en-los-examenes-de-policia-local/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [42], duration: 12 },
    },
    // 5. Curs Online per l'accés a la Guàrdia Urbana de Badalona 2025
    {
        id: 5,
        tax: 0.21,
        sku: "iopos.course.online.ref-2020-007-guardia-urbana-badalona-2024-25",
        title: "Curs Online per l'accés a la Guàrdia Urbana de Badalona 2025",
        name: "Curs Online per l'accés a la Guàrdia Urbana de Badalona 2025",
        description: "Després de l’èxit de la darrera convocatòria, et presentem un curs renovat i en evolució constant per preparar-te al màxim per a la Guàrdia Urbana de Badalona 2025. Temari actualitzat, cultura general, actualitat setmanal amb tests, exàmens oficials i simulacres perquè arribis a la prova amb confiança i avantatge.",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        offer: 89.99,
        offer_text: "Últims dies per l'Oposició!",
        shipment: 0.0,
        images: ["/5/image7"],
        banner: ["/5/image7"],
        link: "/tienda/cursos/curs-guardia-urbana-badalona-curs-online-2025/",
        created_at: "2025-09-16 00:00:01",
        start_at: "2025-09-16 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 30, group_id: [1992] },
        can_be_sent: false,
    },
    // 21. Campus Online de Casos Pràctics d'Entrevista Policial (2025)
    {
        id: 21,
        tax: 0.21,
        sku: "iopos.course.ref-2021-022-campus-online-casos-practics-pol-2026",
        title: "Campus Online de Casos Pràctics d'Entrevista Policial (2026)",
        name: "Campus Online de Casos Pràctics d'Entrevista Policial (2026)",
        description: "Aprèn a superar amb èxit l’entrevista policial treballant amb casos reals, explicacions pas a pas i tècniques que et faran destacar davant el tribunal.",
        category: [product_types_1.Category.PL, product_types_1.Category.Online, product_types_1.Category.GUB],
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/21/image_h"],
        banner: ["/21/image_h"],
        link: "/tienda/cursos/campus-online-casos-practics-dentrevista-oficials-2026/",
        created_at: "2026-06-17 00:00:10",
        start_at: "2026-06-17 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 78, group_id: [66] },
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/21/image_h",
            portrait: "/21/image_v",
        },
        hero: {
            firstTitle: "Campus Online de Casos Pràctics d'Entrevista Policial",
            secondTitle: "Actualitzat per a 2026",
            thirdTitle: "Aprèn a superar amb èxit l’**entrevista policial** treballant amb **casos reals**, explicacions **pas a pas** i tècniques que et faran **destacar davant el tribunal**.",
            landscape: "/21/hero_h",
            portrait: "/21/hero_v",
        },
    },
    // 23. Les 500 preguntes de temari més repetides als examens de policia local (5ª edició)
    {
        id: 23,
        tax: 0.04,
        created_at: "2025-07-28 00:00:07",
        updated_at: "2025-07-28 00:00:07",
        sku: "iopos.book.les-500-preguntes-de-temari-mes-repetides-als-examens-de-policia-local-5-last",
        title: "Les 500 preguntes de temari més repetides als examens de policia local (5ª edició)",
        description: "Posa't al capdavant de la teva preparació amb aquest llibre únic i el mòdul gratuït. Aprofita aquesta oportunitat i assegura el teu èxit!",
        name: "Les 500 preguntes de temari més repetides als examens de policia local (5ª edició)",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        price: 19.99,
        // offer: 34.99,
        // offer_text: "Oferta 25% Sant Jordi 2024!",
        images: ["/23/image3"],
        banner: ["/23/image3"],
        shipment: 4.49,
        link: "/tienda/libros/metodo-a-les-500-preguntes-de-temari-mes-repetides-als-examens-de-policia-local/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        limit: 2,
        app: { modules: [73], duration: 12 },
    },
    // 25. Curs Online de Psicotècnics 2025/2026
    {
        id: 25,
        tax: 0.21,
        sku: "iopos.course.online.ref-2020-005-curs-de-psicotecnics",
        title: "Curs Online de Psicotècnics 2026",
        name: "Curs Online de Psicotècnics 2026",
        category: [
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Online,
            product_types_1.Category.GUB,
        ],
        description: "Descobreix el curs online de psicotècnics més complet i renovat, dissenyat per preparar-te des de zero fins a superar qualsevol oposició de policia. Comença avui mateix!",
        enabled: true,
        stock: true,
        stock_message: "¡Próximamente!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 79.99,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        // recurrent: "monthly",
        shipment: 0.0,
        images: ["/25/image7"],
        banner: ["/25/image7"],
        link: "/tienda/cursos/curs-online-de-psicotecnics-2026/",
        created_at: "2025-07-18 00:00:00",
        start_at: "2025-07-18 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 48, group_id: [529] },
        can_be_sent: false,
        items: 1,
    },
    // 36. Curs de Policia Local 2025/26 (Temari, Actualitat i Cultura General)
    {
        id: 36,
        tax: 0.21,
        sku: "iopos.course.online.ref-open-pl-curs-online-policia-local-2026",
        title: "Curs de Policia Local 2026 (Temari, Actualitat i Cultura General)",
        name: "Curs de Policia Local 2026 (Temari, Actualitat i Cultura General)",
        description: "Prepara't per a les proves d'accés a Policia Local de Catalunya amb el nostre curs interactiu, que inclou temari, cultura general, actualitat i classes setmanals en directe.",
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        enabled: true,
        stock: true,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        // offer: 79.99,
        // offer_text: "¡Promo cursos presenciales y online",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/36/image1"],
        banner: ["/36/image1"],
        link: "/tienda/cursos/curs-de-policia-local-2026/",
        created_at: "2026-02-05 00:00:07",
        start_at: "2026-02-05 00:00:07",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 148, group_id: [2111] },
        can_be_sent: false,
        items: 1,
    },
    // 57. Les 500 preguntes de Cultura General més repetides als exàmens de Policia Local 2.0
    {
        id: 57,
        tax: 0.04,
        created_at: "2025-06-30 00:00:07",
        start_at: "2025-06-30 00:00:07",
        sku: "iopos.book.cultura-general-20",
        title: "Les 500 preguntes de Cultura General més repetides als exàmens de Policia Local 2.0",
        description: "Método A 2.0",
        name: "Método A 2.0",
        enabled: false,
        stock: false,
        stock_message: "Esgotat!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        price: 5.99,
        offer: 34.99,
        offer_text: "Remat final!",
        images: ["/57/image2"],
        banner: ["/57/image2"],
        shipment: 4.49,
        link: "/tienda/libros/metodo-a-las-500-preguntas-mas-repetidas-en-los-examenes-de-policia-local-2-0/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [77], duration: 12 },
    },
    // 98. Las 500 preguntas imprescindibles para ser Guardia Civil
    {
        id: 98,
        tax: 0.04,
        sku: "iopos.book.las-500-impresincibles-para-ser-guardia-civil",
        category: [product_types_1.Category.Books],
        title: "Las 500 preguntas imprescindibles para ser Guardia Civil",
        name: "Las 500 preguntas imprescindibles para ser Guardia Civil",
        description: "¡Prepárate para ser Guardia Civil con las 500 preguntas clave! Con nuestro libro y la app, dominarás la prueba de temario y estarás listo para el examen real. ¡Haz tu sueño realidad!",
        enabled: false,
        stock: false,
        stock_message: "Pronto disponible!",
        type: product_types_1.Type.Book,
        price: 34.99,
        images: ["/98/image3"],
        banner: ["/98/image3"],
        shipment: 4.49,
        link: "/tienda/libros/las-500-preguntas-imprescindibles-para-ser-guardia-civil/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [84], duration: 6 },
        created_at: "2025-06-30 00:00:09",
        start_at: "2025-06-30 00:00:09",
    },
    // 114. Les 500 preguntes imprescindibles per accedir al cos de la Guàrdia Urbana de l'Hospitalet
    {
        id: 114,
        tax: 0.04,
        created_at: "2025-08-27 00:00:00",
        start_at: "2025-08-27 00:00:00",
        sku: "iopos.book.les-500-preguntes-imprescindibles-per-accedir-al-cos-de-la-guardia-urbana-dhospitalet",
        category: [product_types_1.Category.Books, product_types_1.Category.PL, product_types_1.Category.OFERTA],
        name: "Les 500 preguntes imprescindibles per accedir al cos de la Guàrdia Urbana de l'Hospitalet",
        title: "Les 500 preguntes imprescindibles per accedir al cos de la Guàrdia Urbana de l'Hospitalet",
        description: "Prepara't per aprovar amb nota! El llibre definitiu amb les 500 preguntes clau per superar la part específica de la Guàrdia Urbana de l'Hospitalet.",
        enabled: false,
        stock: false,
        stock_message: "¡Agotado!",
        type: product_types_1.Type.Book,
        price: 4.99,
        offer: 34.99,
        offer_text: "Últimes unitats a la venda!",
        images: ["/114/image3"],
        banner: ["/114/image3"],
        shipment: 4.49,
        link: "/tienda/libros/les-500-preguntes-imprescindibles-per-accedir-al-cos-de-la-guardia-urbana-de-lhospitalet/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [86], duration: 12 },
    },
    // Les 500 preguntes imprescindibles per accedir a la Guàrdia Urbana de Badalona
    {
        id: 115,
        created_at: "2025-08-25 00:00:02",
        start_at: "2025-08-25 00:00:02",
        sku: "iopos.book.les-500-preguntes-imprescindibles-per-accedir-a-la-guardia-urbana-de-badalona",
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        title: "Les 500 preguntes imprescindibles per accedir a la Guàrdia Urbana de Badalona",
        description: "Prepara't per destacar a les proves de la Guàrdia Urbana de Badalona amb el llibre que reuneix les 500 preguntes clau, respostes i explicacions per superar l'examen amb seguretat.",
        name: "Les 500 preguntes imprescindibles per accedir a la Guàrdia Urbana de Badalona",
        enabled: false,
        stock: false,
        stock_message: "Pronto disponible!",
        type: product_types_1.Type.Book,
        tax: 0.04,
        price: 4.99,
        offer: 34.99,
        offer_text: "Últimes unitats a la venda!",
        images: ["/115/image2"],
        banner: ["/115/image2"],
        shipment: 4.49,
        link: "/tienda/libros/les-500-preguntes-imprescindibles-per-accedir-al-cos-de-la-guardia-urbana-de-badalona/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [87], duration: 12 },
    },
    // Curs Online Guàrdia Urbana Barcelona (2025)
    {
        id: 128,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.GUB],
        sku: "iopos.course.online.ref-2021-077-curs-per-lacces-a-guardia-urbana-de-barcelona-25",
        title: "Curs Online Guàrdia Urbana Barcelona (2025)",
        name: "Curs Online Guàrdia Urbana Barcelona (2025)",
        description: "Prepara't per l'accés a la Guàrdia Urbana de Barcelona amb el nostre curs online de 5 estrelles, amb temari actualitzat, classes en directe i tot el material que necessites per triomfar!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 599.99,
        // offer: 149.99,
        // offer_text: "A per l'Oposició!",
        // split_payment: "Fracciona el pagament amb PayPal en 3 còmodes quotes de 49,99 €!",
        shipment: 0.0,
        images: ["/128/image7"],
        banner: ["/128/image7"],
        link: "/tienda/cursos/curs-online-guardia-urbana-barcelona-2025/",
        created_at: "2025-07-16 00:00:11",
        start_at: "2025-07-16 00:00:11",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 12, group_id: [1453] },
    },
    // Pla iOpos Formatiu
    {
        id: 139,
        tax: 0.21,
        hidden: false,
        sku: "iopos.course.online.ref-2021-083-plan-iopos-formatiu",
        title: "Pla iOpos Formatiu",
        name: "Pla iOpos Formatiu",
        category: [
            product_types_1.Category.PLANES,
            /*Category.Online,
                Category.Mossos,
                Category.FaceToFace,
                Category.GUB,
                Category.PL,
                Category.Mossos,*/
        ],
        description: "Amb el Pla iOpos inverteix en el teu futur i aprofita el 95% d'èxit dels nostres alumnes!",
        enabled: false,
        stock: false,
        stock_message: "Sin stock.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 1499.99,
        split_payment: "Divideix el pagament en 3 còmodes quotes de 499,99 €!",
        // offer: 999.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/139/image6"],
        banner: ["/139/image6"],
        link: "/tienda/cursos/pla-iopos-formatiu/",
        created_at: "2025-12-31 00:00:12",
        start_at: "2025-12-31 00:00:12",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Resolució de Casos Pràctics Policials
    {
        id: 145,
        tax: 0.04,
        created_at: "2025-09-23 00:00:10",
        start_at: "2025-09-23 00:00:10",
        category: [product_types_1.Category.ISPC, product_types_1.Category.Books, product_types_1.Category.PL, product_types_1.Category.CP],
        sku: "iopos.book.resolucio-de-casos-practics-policials-3a",
        title: "Resolució de Casos Pràctics Policials",
        name: "Resolució de Casos Pràctics Policials",
        description: "Casos pràctics d'exàmens oficials, perfectes per preparar oposicions i ascensos policials. Una eina clau per millorar les teves opcions!",
        enabled: true,
        stock: true,
        stock_message: "Sense estoc.",
        type: product_types_1.Type.Book,
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Últimes unitats!",
        images: ["/145/image1"],
        banner: ["/145/image1"],
        shipment: 4.49,
        link: "/tienda/libros/resolucio-de-casos-practics-policials/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 725,
    },
    // Revisió d'Exclusions Mèdiques
    {
        id: 163,
        tax: 0.0,
        category: [product_types_1.Category.Certificates],
        sku: "iopos.course.online.ref-2021-091-revisio-exclusions-mediques",
        title: "Revisió d'Exclusions Mèdiques",
        name: "Revisió d'Exclusions Mèdiques",
        description: "Supera els requisits mèdics per les teves oposicions amb la revisió més completa i professional, adaptada a les bases oficials!",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 39.99,
        shipment: 0.0,
        images: ["/163/image_h"],
        banner: ["/163/image_h"],
        link: "/tienda/cursos/revisio-exclusions-mediques/",
        special_buy: "/tienda/cursos/revisio-exclusions-mediques/#disponibles",
        created_at: "2026-06-05 00:00:01",
        start_at: "2026-06-05 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        sendInstructionsEmail: true,
        hero: {
            firstTitle: "Revisió d'Exclusions Mèdiques",
            secondTitle: "Prepara't per superar els requisits mèdics amb la revisió més completa i professional, adaptada a les bases oficials!",
            thirdTitle: "Supera els requisits mèdics per les teves oposicions amb la revisió més completa i professional, adaptada a les bases oficials!",
            landscape: "/163/hero_h",
            portrait: "/163/hero_v",
        },
        productImage: {
            landscape: "/163/image_h",
            portrait: "/163/image_v",
        },
        calendly_schedule: [
            {
                id: 1,
                name: "Badamèdic #1",
                position: "",
                description: "La tranquilidad de llegar preparado empieza con un chequeo previo.",
                location: "Carrer de Baldomer Solà, 80, 08912 Badalona, Barcelona",
                link: "https://calendly.com/iopos-academia-badamedic1/exclusions-mediques",
            },
            {
                id: 2,
                name: "Badamèdic #2",
                position: "",
                description: "La tranquilidad de llegar preparado empieza con un chequeo previo.",
                location: "Carrer de Baldomer Solà, 80, 08912 Badalona, Barcelona",
                link: "https://calendly.com/iopos-academia-badamedic2/exclusions-mediques",
            },
        ],
    },
    // Les 500 preguntes imprescindibles per a l'ISPC
    {
        id: 175,
        tax: 0.04,
        category: [product_types_1.Category.Books, product_types_1.Category.ISPC, product_types_1.Category.OFERTA],
        sku: "iopos.book.les-500-preguntes-imprescindibles-per-a-lispc",
        title: "Les 500 preguntes imprescindibles per a l'ISPC",
        name: "Les 500 preguntes imprescindibles per a l'ISPC",
        description: "El llibre imprescindible per aprovar el curs bàsic amb seguretat i confiança.",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc",
        type: product_types_1.Type.Book,
        price: 4.99,
        offer: 34.99,
        offer_text: "Oferta últimes unitats!",
        shipment: 4.49,
        images: ["/175/image2"],
        banner: ["/175/image2"],
        link: "/tienda/libros/les-500-preguntes-imprescindibles-per-a-lispc/",
        created_at: "2025-08-25 00:00:05",
        start_at: "2025-08-25 00:00:05",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 300,
    },
    // Pack Mossos Total (2025/2026)
    {
        id: 184,
        tax: 0.04,
        sku: "iopos.book.pack.mossos-total-2026",
        title: "Pack Mossos Total 2026",
        name: "Pack Mossos Total 2026",
        description: "Tot l'any de preparació, tot el contingut que necessites i totes les eines per dominar el temari: amb el Pack Mossos Total, arribes al màxim nivell amb una sola elecció.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        price: 189.99,
        offer: 239.96,
        offer_text: "Estalvia 50 € amb aquest pack complet i de llarga durada!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/184/image7"],
        banner: ["/184/image7"],
        link: "/tienda/libros/pack-mossos-total-2026",
        created_at: "2025-06-30 00:00:02",
        start_at: "2025-06-30 00:00:02",
        more_info: true,
        can_be_sent: true,
        items: 3,
        discount_not_applicable: true,
        pack: true,
        pack_items: [901, 453, 611],
        app: { modules: [1], duration: 12 },
        note: "Pack Mossos Total (1001 + Dossier + Guia",
        weight: 1830,
        shipping_price: 5.99,
    },
    // Les 500 preguntes imprescindibles per a ser Guàrdia Urbana de Reus
    {
        id: 202,
        created_at: "2022-01-21 00:00:00",
        start_at: "2022-01-21 00:00:00",
        sku: "iopos.book.les-500-preguntes-imprescindibles-per-a-ser-guardia-urbana-de-reus",
        title: "Les 500 preguntes imprescindibles per a ser Guàrdia Urbana de Reus",
        name: "Les 500 preguntes imprescindibles per a ser Guàrdia Urbana de Reus",
        description: "Aconsegueix la teva plaça a la Policia Local de Reus amb el llibre que ja està ajudant els aspirants a aprovar amb nota!",
        enabled: false,
        stock: false,
        stock_message: "Estoc esgotat!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        price: 4.99,
        tax: 0.04,
        offer: 34.99,
        offer_message: "Últimes unitats a la venda!",
        offer_text: "Últimes unitats a la venda!",
        images: ["/202/image1"],
        banner: ["/202/image1"],
        shipment: 4.49,
        link: "/tienda/libros/les-500-preguntes-imprescindibles-per-a-ser-guardia-urbana-de-reus/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [94], duration: 12 },
    },
    // Llibre Psicotècnics Aptitudinals
    {
        id: 205,
        tax: 0.04,
        created_at: "2024-09-06 00:00:01",
        start_at: "2024-09-06 00:00:01",
        sku: "iopos.book.llibre-psicotecnics-aptitudinals-4",
        title: "Llibre Psicotècnics Aptitudinals",
        name: "Llibre Psicotècnics Aptitudinals",
        description: "L'èxit no és fruit de la casualitat, sinó de l'esforç. Aquest llibre és la teva eina imprescindible per dominar els psicotècnics aptitudinals.",
        enabled: true,
        stock: true,
        stock_message: "Sense estoc temporalment",
        type: product_types_1.Type.Book,
        category: [
            product_types_1.Category.Books,
            product_types_1.Category.Mossos,
            product_types_1.Category.PL,
            product_types_1.Category.Psicos,
        ],
        price: 69.99,
        // offer: 69.99,
        // offer_text: "Oferta 25% Sant Jordi 2024!",
        images: ["/205/image6"],
        banner: ["/205/image6"],
        shipment: 4.49,
        link: "/tienda/libros/llibre-psicotecnics-aptitudinals/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 1643,
        shipping_price: 6.99,
        /*app: { modules: [96], duration: 1 },*/
    },
    // Simulacre d'Entrevista 2025 (1:00 h)
    {
        id: 241,
        tax: 0.0,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE3,
        ],
        sku: "iopos.course.ref-2021-entrevista-personal-roleplay-2025",
        title: "Simulacre d'Entrevista 2025 (1:00 h)",
        name: "Simulacre d'Entrevista 2025 (1:00 h)",
        description: "Prepara't amb els millors i afronta la teva entrevista amb seguretat. Reserva el teu simulacre ara!",
        enabled: false,
        stock: false,
        special_buy: "/tienda/cursos/simulacre-dentrevista-policial-2025-1h/#disponibles",
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/241/image5"],
        banner: ["/241/image5"],
        link: "/tienda/cursos/simulacre-dentrevista-policial-2025-1h/",
        created_at: "2025-03-06 00:00:01",
        start_at: "2025-03-06 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Los 17 de Kabul: Cuando la realidad supera la ficción
    {
        id: 242,
        tax: 0.04,
        created_at: "2025-06-30 00:00:08",
        start_at: "2025-06-30 00:00:08",
        sku: "gatoesfinge.book.los17dekabul",
        name: "Los 17 de Kabul: Cuando la realidad supera la ficción",
        title: "Los 17 de Kabul: Cuando la realidad supera la ficción",
        description: "El mundo se desmorona en Kabul. 17 agentes. Una mujer. Una operación imposible",
        enabled: true,
        stock: true,
        stock_message: "¡Agotado!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books],
        price: 19.99,
        // offer: 19.99,
        // offer_text: "Oferta 25% Sant Jordi 2024!",
        images: ["/242/image4"],
        banner: ["/242/image4"],
        shipment: 4.49,
        link: "/tienda/libros/los-17-de-kabul-cuando-la-realidad-supera-la-ficcion/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 500,
    },
    // Certificat Mèdic Oficial (Guàrdia Urbana i Policies Locals)
    {
        id: 266,
        category: [product_types_1.Category.Certificates],
        tax: 0.21,
        sku: "iopos.certificate.ref-2021-091-certificat-medic-oficial-gub-pl",
        title: "Certificat Mèdic Oficial (Guàrdia Urbana i Policies Locals)",
        name: "Certificat Mèdic Oficial (Guàrdia Urbana i Policies Locals)",
        description: "Supera els requisits mèdics per les teves oposicions amb la revisió més completa i professional, adaptada a les bases oficials!",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 29.99,
        shipment: 0.0,
        images: ["/266/image_h"],
        banner: ["/266/image_h"],
        link: "/tienda/curso/certificat-medic-oficial-gub-pl/",
        special_buy: "/tienda/curso/certificat-medic-oficial-gub-pl/#disponibles",
        created_at: "2024-05-22 00:00:02",
        start_at: "2024-05-22 00:00:02",
        more_info: true,
        can_be_sent: false,
        items: 1,
        // sendInstructionsEmail: true,
        productImage: {
            landscape: "/266/image_h",
            portrait: "/266/image_v",
        },
        hero: {
            landscape: "/266/hero_h",
            portrait: "/266/hero_v",
            firstTitle: "Certificat Mèdic Oficial",
            secondTitle: "Guàrdia Urbana · PL",
            thirdTitle: "Supera els **requisits mèdics** per les teves oposicions amb la **revisió més completa i professional**, adaptada a les **bases oficials**!",
        },
        calendly_schedule: [
            {
                id: 1,
                name: "Badamèdic #1",
                position: "",
                description: "La tranquilidad de llegar preparado empieza con un chequeo previo.",
                location: "Carrer de Baldomer Solà, 80, 08912 Badalona, Barcelona",
                link: "https://calendly.com/iopos-academia-badamedic1/certificat-medic-oficial",
            },
            {
                id: 2,
                name: "Badamèdic #2",
                position: "",
                description: "La tranquilidad de llegar preparado empieza con un chequeo previo.",
                location: "Carrer de Baldomer Solà, 80, 08912 Badalona, Barcelona",
                link: "https://calendly.com/iopos-academia-badamedic2/certificat-medic-oficial",
            },
        ],
    },
    // Curs Online per la Guàrdia Urbana de l'Hospitalet 2025
    {
        id: 308,
        tax: 0.21,
        sku: "iopos.course.online.2025-close-guardia-urbana-hospitalet-2025",
        title: "Curs Online per la Guàrdia Urbana de l'Hospitalet 2025",
        name: "Curs Online per la Guàrdia Urbana de l'Hospitalet 2025",
        description: "El curs més complet i actualitzat per preparar-te amb èxit per a la Guàrdia Urbana de l'Hospitalet, amb temari, exàmens, simulacres i acompanyament exclusiu",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        offer: 89.99,
        offer_text: "Últim sprint!",
        shipment: 0.0,
        images: ["/308/image3"],
        banner: ["/308/image3"],
        link: "/tienda/cursos/curs-online-guardia-urbana-de-lhospitalet-2025/",
        created_at: "2025-06-13 00:00:01",
        start_at: "2025-06-13 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 133, group_id: [2598] },
        can_be_sent: false,
        items: 1,
    },
    // Pack Mossos Imprescindibles (Psicos + Guia) [2025/2026]
    {
        id: 310,
        tax: 0.04,
        sku: "iopos.book.pack.mossos-imprescindibles-psicos-guia-2026",
        title: "Pack Mossos Imprescindibles (Psicos + Guia) 2026",
        name: "Pack Mossos Imprescindibles (Psicos + Guia) 2026",
        description: "El teu primer pas cap a la plaça comença aquí: amb el Pack Mossos Imprescindible estudies amb claredat, entrenes amb sentit i avances amb seguretat.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        price: 94.99,
        offer: 129.98,
        offer_text: "Estalvia diners amb els packs iOpos!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/310/image8"],
        banner: ["/310/image8"],
        link: "/tienda/libros/pack-mossos-imprescindibles-psicos-guia-2026/",
        created_at: "2025-06-30 00:00:01",
        start_at: "2025-06-30 00:00:01",
        more_info: true,
        can_be_sent: true,
        items: 2,
        pack: true,
        discount_not_applicable: true,
        pack_items: [205, 453],
        note: "Pack Mossos Imprescindibles (Psicos + Guia)",
        weight: 1643,
        shipping_price: 5.99,
    },
    // Les 500 imprescindibles per a Tarragona
    {
        id: 312,
        tax: 0.04,
        sku: "iopos.book.iopos.book.les-500-imprescindibles-de-tarragona",
        title: "Les 500 imprescindibles per a Tarragona",
        name: "Les 500 imprescindibles per a Tarragona",
        description: "Prepara't per a la Guàrdia Urbana de Tarragona amb 500 preguntes clau i accés gratuït a un mòdul de pràctica durant un any.",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        subtype: product_types_1.Subtype.Online,
        // recurrent: "monthly",
        price: 4.99,
        offer: 34.99,
        offer_text: "Remat final!",
        shipment: 0.0,
        images: ["/312/image5"],
        banner: ["/312/image5"],
        link: "/tienda/libros/les-500-imprescindibles-per-a-tarragona/",
        created_at: "2025-06-30 00:00:08",
        start_at: "2025-06-30 00:00:08",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: true,
        items: 1,
        app: { modules: [107], duration: 12 },
    },
    // Curs Online per la Guàrdia Urbana de Tarragona 2025 (Accés fins dia examen)
    {
        id: 314,
        tax: 0.21,
        sku: "iopos.course.online-tarragona-2026",
        title: "Curs Online per la Guàrdia Urbana de Tarragona 2026",
        name: "Curs Online per la Guàrdia Urbana de Tarragona 2026",
        description: "Aprova les oposicions a la Guàrdia Urbana de Tarragona amb el curs online més complet, actualitzat i flexible: tot el que necessites en un sol lloc.",
        enabled: true,
        stock: false,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_text: "Sprint final!",
        offer_message: "Sprint final!",
        shipment: 0.0,
        images: ["/314/image4"],
        banner: ["/314/image4"],
        link: "/tienda/cursos/curs-online-guardia-urbana-de-tarragona-2026/",
        created_at: "2026-05-13 00:00:01",
        start_at: "2026-05-13 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 103, group_id: [2676] },
        can_be_sent: false,
        items: 1,
        availableUntilExam: true,
    },
    // Curs Online per la Policia Local Castelldefels 2025
    {
        id: 316,
        tax: 0.21,
        sku: "iopos.course.online.2025-open-033-policia-local-castelldefels",
        title: "Curs Online per la Policia Local Castelldefels 2025",
        name: "Curs Online per la Policia Local Castelldefels 2025",
        description: "Abans de tot cal recordar que més del 83% dels aspirants aptes en l'anterior convocatòria de la policia local de Castelldefels 2024 van ser alumnes nostres, inclosos el núm. 1 i 2.",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 59.99,
        offer: 89.99,
        offer_text: "Últim sprint!",
        shipment: 0.0,
        images: ["/316/image5"],
        banner: ["/316/image5"],
        link: "/tienda/cursos/curs-online-per-policia-local-de-castelldefels-2025/",
        created_at: "2025-03-14 00:00:01",
        start_at: "2025-03-14 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 138, group_id: [2171] },
        can_be_sent: false,
        items: 1,
    },
    // Guia d'Accés per a Policies Locals de Catalunya (2025)
    {
        id: 318,
        tax: 0.04,
        sku: "iopos.book.iopos.book.guia-dacces-per-policies-locals-catalunya-3a-edicio",
        title: "Guia d'Accés per a Policies Locals de Catalunya (2025)",
        name: "Guia d'Accés per a Policies Locals de Catalunya (2025)",
        description: "Prepara't amb el millor recurs per accedir a la Policia Local de Catalunya: un llibre creat des de l'experiència, dissenyat per ajudar-te a aconseguir la teva plaça amb confiança i eficàcia!",
        enabled: true,
        stock: false,
        stock_message: "Sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL /*Category.OFERTA*/],
        subtype: product_types_1.Subtype.Online,
        // recurrent: "monthly",
        price: 29.99,
        offer: 59.99,
        offer_text: "Últimes unitats!",
        shipment: 0.0,
        images: ["/318/image3"],
        banner: ["/318/image3"],
        link: "/tienda/libros/guia-dacces-per-policies-locals-catalunya-2a-edicio/",
        created_at: "2025-09-23 00:00:10",
        start_at: "2025-09-23 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: true,
        items: 1,
        weight: 629,
    },
    // Webinar Guàrdia Urbana de Badalona (20 d'octubre - 3 hores)
    {
        id: 326,
        tax: 0.21,
        sku: "iopos.course.ref-2021-086-curs-online-webinar-gua-urba-badalona-20-octubre",
        title: "Webinar Guàrdia Urbana de Badalona (20 d'octubre - 3 hores)",
        name: "Webinar Guàrdia Urbana de Badalona (20 d'octubre - 3 hores)",
        description: "Un webinar intensiu de 3 hores on repassarem, de forma clara i directa, tots els conceptes clau de les convocatòries de la Guàrdia Urbana de Badalona, enfocats exactament al que pot sortir a examen.",
        enabled: true,
        stock: false,
        category: [product_types_1.Category.PL],
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 24.99,
        // price: 24.99,
        // offer: 29.99,
        // offer_text: "",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/326/image1"],
        banner: ["/326/image1"],
        link: "/tienda/cursos/webinar-guardia-urbana-badalona-20-octubre/",
        created_at: "2022-09-27 00:00:01",
        start_at: "2022-09-27 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 346, group_id: [1092] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Exprés de Personalitat i Aptitudinals per Agent Rural (14 Gener - 6 hores)
    {
        id: 350,
        tax: 0.0,
        sku: "iopos.course.ref-2022-109-curs-presencial-rurals-6h-psicos-14-gen",
        title: "Curs Exprés de Personalitat i Aptitudinals per Agent Rural (14 Gener - 6 hores)",
        name: "Curs Exprés de Personalitat i Aptitudinals per Agent Rural (14 Gener - 6 hores)",
        category: [product_types_1.Category.FaceToFace],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 69.99,
        // offer: 179.99,
        // offer_text: "¡Promo cursos presenciales y online",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/350/image3"],
        banner: ["/350/image3"],
        link: "/tienda/cursos/curs-expres-personalitat-aptitudinals-agent-rural-14-gener/",
        created_at: "2022-12-28 00:00:01",
        start_at: "2022-12-28 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 423, group_id: [1194] },
        can_be_sent: false,
        items: 1,
    },
    // Curs d'Actualitat i Cultura General 2025
    {
        id: 355,
        tax: 0.21,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        sku: "iopos.course.online.ref-2021-074-curs-actualitat-i-cultura-general-2026",
        title: "Curs d'Actualitat i Cultura General 2026",
        name: "Curs d'Actualitat i Cultura General 2026",
        description: "L'únic curs que et manté al dia amb l'actualitat i et prepara per triomfar als exàmens de cultura general!",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 34.99,
        // offer: 39.99,
        // offer_text: "¡Black Friday en iOpos!",
        shipment: 0.0,
        images: ["/355/image6"],
        banner: ["/355/image6"],
        link: "/tienda/cursos/curs-actualitat-i-cultura-general-2026",
        created_at: "2026-02-10 00:00:02",
        start_at: "2026-02-10 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 310, group_id: [1206] },
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Curs d'Actualitat i Cultura General",
            secondTitle: "Actualitzat a 2026",
            thirdTitle: "**L'únic curs** que et manté **al dia** amb l'**actualitat** i et prepara per **triomfar** als **exàmens de cultura general**!",
            landscape: "/355/hero_h",
            portrait: "/355/hero_v",
        },
    },
    // Curs Online d'Accés Policia Municipal de Terrassa 2025
    {
        id: 395,
        tax: 0.21,
        sku: "iopos.course.online.ref-2025-close-terr-curs-online-pol-mun-terrassa-2025",
        title: "Curs Online d'Accés Policia Municipal de Terrassa 2025",
        name: "Curs Online d'Accés Policia Municipal de Terrassa 2025",
        description: "Prepara't amb el millor curs per a la Policia Municipal de Terrassa i assegura't l'èxit amb materials actualitzats, classes en directe i simulacres reals. No deixis passar aquesta oportunitat! 🚀",
        enabled: false,
        stock: false,
        stock_message: "No disponible.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        price: 49.99,
        offer: 89.99,
        offer_text: "Últims dies!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/395/image4"],
        banner: ["/395/image4"],
        link: "/tienda/cursos/curs-online-policia-municipal-de-terrassa-2025/",
        created_at: "2025-02-19 00:00:00",
        start_at: "2025-02-19 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 123, group_id: [2165] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Mossos d'Esquadra 2026 (Àmbits A, B, C i D)
    {
        id: 408,
        tax: 0.21,
        sku: "iopos.course.online.ref-2022-010-curs-mossos-desquadra-ambit-abcd-2026",
        title: "Curs Mossos d'Esquadra 2026 (Àmbits A, B, C i D)",
        name: "Curs Mossos d'Esquadra 2026 (Àmbits A, B, C i D)",
        description: "Prepara't per a Mossos amb el curs més complet d'iOpos Acadèmia: metodologia clara, classes en directe i suport constant perquè arribis a l'examen amb seguretat i resultats.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        price: 39.99,
        offer: 599.99,
        offer_text: "Oferta especial!",
        offer_message: "Oferta especial!",
        split_payment: "Possibilitat de pagament en 3 quotes sense interessos *",
        shipment: 0.0,
        images: ["/408/image1"],
        banner: ["/408/image1"],
        link: "/tienda/cursos/curs-mossos-esquadra-2026-ambits-abcd/",
        created_at: "2026-04-07 00:00:01",
        start_at: "2026-04-07 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: {
            course_id: 18,
            group_id: [2710],
        },
        /*send_documents: [
            {
                title: "Resums-Temari-Curs-Online-CME-2026.pdf",
                url: "https://dhl2zczmpt4xp.cloudfront.net/RESUMS_TEMARI_2026_ONLINE_CME_bb58536ce4.pdf",
            },
        ],*/
        hero: {
            firstTitle: "Curs Online Mossos d'Esquadra 2026",
            secondTitle: "Àmbits A, B, C i D",
            thirdTitle: "**Prepara't per a Mossos** amb el **curs més complet** d'iOpos Acadèmia: **metodologia clara**, **classes en directe** i **suport constant** perquè arribis a l'**examen** amb **seguretat** i **resultats**.",
            landscape: "/408/hero_h",
            portrait: "/408/hero_v",
        },
        availableUntilExam: true,
    },
    // Curs Intensiu Català C1 Online (accés durant 60 dies)
    {
        id: 435,
        tax: 0.21,
        sku: "iopos.course.online.ref-2021-121-curs-intensiu-catala-c1-online",
        title: "Curs Intensiu Català C1 Online (accés durant 60 dies)",
        name: "Curs Intensiu Català C1 Online (accés durant 60 dies)",
        category: [
            product_types_1.Category.PL,
            product_types_1.Category.Mossos,
            product_types_1.Category.GUB,
            product_types_1.Category.Others,
            product_types_1.Category.Online,
        ],
        description: "Arriba el curs ultra intensiu per preparar el català C1 en només 2 mesos! Tot el material autocorregible i didàctic. Comença avui mateix!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 199.99,
        // offer_text: "¡Enamórate de iOpos!",
        //recurrent: 'monthly',
        shipment: 0.0,
        images: ["/435/image5"],
        banner: ["/435/image5"],
        link: "/tienda/cursos/curs-intensiu-catala-c1-online/",
        created_at: "2025-01-13 00:00:07",
        start_at: "2025-01-13 00:00:07",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: {
            course_id: 483,
            group_id: [1488],
            // limit: 30,
        },
        can_be_sent: false,
        items: 1,
    },
    // Curs Online Intensiu ACTIC (Nivell Mitjà) [Accés durant 90 dies]
    {
        id: 443,
        tax: 0.21,
        sku: "iopos.course.ref-2021-121-curs-online-intensiu-actic-nivell-mitja",
        title: "Curs Online Intensiu ACTIC (Nivell Mitjà) [Accés durant 90 dies]",
        name: "Curs Online Intensiu ACTIC (Nivell Mitjà) [Accés durant 90 dies]",
        category: [product_types_1.Category.Others, product_types_1.Category.Online],
        description: "📚 Domina l'acTIC nivell mitjà amb el nostre curs 100% online! 🚀 Aprèn amb vídeos explicatius, pràctiques interactives i tot el que necessites per superar la prova oficial.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 39.99,
        // offer: 0.0,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/443/image1"],
        banner: ["/443/image1"],
        link: "/tienda/cursos/curs-online-intensiu-actic-nivell-mitja/",
        created_at: "2024-10-04 00:00:07",
        start_at: "2024-10-04 00:00:07",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 492, group_id: [1521] },
        can_be_sent: false,
        items: 1,
    },
    // Les 500 preguntes imprescindibles per accedir a la Policia Municipal de Terrassa (2a edició)
    {
        id: 439,
        tax: 0.04,
        sku: "iopos.book.les-500-imprescindibles-per-a-ser-policia-municipal-de-terrassa-2a-edicio",
        title: "Les 500 preguntes imprescindibles per accedir a la Policia Municipal de Terrassa (2a edició)",
        name: "Les 500 preguntes imprescindibles per accedir a la Policia Municipal de Terrassa (2a edició)",
        description: "El recurs imprescindible per aprovar amb nota les oposicions a la Policia Municipal de Terrassa: 500 preguntes reals i actualitzades, amb respostes i explicacions clares.”",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        price: 4.99,
        offer: 34.99,
        offer_text: "Oferta especial últimes unitats!",
        shipment: 4.49,
        images: ["/439/image1"],
        banner: ["/439/image1"],
        link: "/tienda/libros/les-500-preguntes-imprescindibles-per-accedir-policia-municipal-de-terrassa-2a-edicio/",
        created_at: "2025-08-25 00:00:01",
        start_at: "2025-08-25 00:00:01",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [97], duration: 12 },
    },
    // 453. Guia Ràpida Coneixements Mossos d'Esquadra 2026
    {
        id: 453,
        tax: 0.04,
        sku: "iopos.book.guia-rapida-coneixements-mossos-26-11",
        title: "Guia Ràpida Coneixements Mossos d'Esquadra 2026",
        name: "Guia Ràpida Coneixements Mossos d'Esquadra 2026",
        description: "Simplificaràs l'estudi del temari amb resums clars i preguntes clau dels exàmens anteriors, i afrontaràs cada prova amb confiança.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Últimes unitats!",
        images: ["/453/image3"],
        banner: ["/453/image3"],
        shipment: 4.49,
        link: "/tienda/libros/guia-rapida-coneixements-mossos-desquadra-2026/",
        more_info: true,
        can_be_sent: true,
        items: 1,
        created_at: "2026-07-16 00:00:10",
        start_at: "2026-07-16 00:00:10",
        weight: 748,
    },
    // Pack Psicos Genius (2025/2026)
    {
        id: 464,
        tax: 0.04,
        sku: "iopos.book.pack.psicos-genius-2026",
        title: "Pack Psicos Genius 2026",
        name: "Pack Psicos Genius 2026",
        description: "Activa el teu potencial amb el Pack Psicotècnics Genius: entrena on vulguis, com vulguis… i prepara't per guanyar!",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        price: 99.99,
        offer: 139.98,
        offer_text: "Estalvia gairebé 40 € amb aquest pack complert!",
        shipment: 4.49,
        images: ["/464/image3"],
        banner: ["/464/image3"],
        link: "/tienda/libros/pack-psicos-genius-2026",
        created_at: "2025-06-30 00:00:03",
        start_at: "2025-06-30 00:00:03",
        more_info: true,
        can_be_sent: true,
        items: 1,
        app: { modules: [96], duration: 6 },
        discount_not_applicable: true,
        pack: true,
        pack_items: [205],
        note: "Pack Psicos Genius (Psicos)",
        weight: 1643,
        shipping_price: 5.99,
    },
    // Pack Mossos Coneixements Pro (2025/2026)
    {
        id: 466,
        tax: 0.04,
        sku: "iopos.book.pack.mossos-coneixements-pro-2026",
        title: "Pack Mossos Coneixements Pro 2026",
        name: "Pack Mossos Coneixements Pro 2026",
        description: "Tot el temari, totes les eines, una sola estratègia: amb el Pack Mossos Coneixements Pro, estudies amb cap i arribes amb garanties.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        price: 124.99,
        offer: 179.98,
        offer_text: "Estalvia diners amb els packs iOpos!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/466/image4"],
        banner: ["/466/image4"],
        link: "/tienda/libros/pack-mossos-coneixements-pro-2026",
        created_at: "2025-06-30 00:00:01",
        start_at: "2025-06-30 00:00:01",
        more_info: true,
        can_be_sent: true,
        items: 2,
        discount_not_applicable: true,
        pack: true,
        pack_items: [611, 453],
        app: { modules: [1], duration: 6 },
        note: "Pack Mossos Coneixements Pro (Guia + Dossier)",
        weight: 1487,
        shipping_price: 5.99,
    },
    // Pack GUB Coneixements Pro (2025/2026)
    {
        id: 518,
        tax: 0.04,
        sku: "iopos.book.pack.gub-coneixements-pro-2026",
        title: "Pack GUB Coneixements Pro 2026",
        name: "Pack GUB Coneixements Pro 2026",
        description: "La combinació perfecta per aprovar l'oposició: estudia amb llibres, entrena amb l'app iGuB i aconsegueix la teva plaça amb confiança.",
        enabled: true,
        stock: false,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.Packs],
        price: 149.99,
        offer: 179.98,
        offer_text: "Estalvia diners amb els packs iOpos!",
        shipment: 4.49,
        images: ["/518/image2"],
        banner: ["/518/image2"],
        link: "/tienda/libros/pack-gub-coneixements-pro-2026",
        created_at: "2025-07-09 00:00:01",
        start_at: "2025-07-09 00:00:01",
        more_info: true,
        can_be_sent: true,
        items: 3,
        app: { modules: [2], duration: 6 },
        pack: true,
        pack_items: [900],
        discount_not_applicable: true,
        note: "Pack GUB Coneixements Pro (Temari)",
        weight: 3215,
        shipping_price: 11.99,
    },
    // Pack GUB Gold (2025/2026)
    {
        id: 519,
        tax: 0.04,
        sku: "iopos.book.pack.gub-gold-2026",
        title: "Pack GUB Gold 2026",
        name: "Pack GUB Gold 2026",
        description: "Fes el salt de qualitat i aconsegueix la teva plaça amb el pack més complet, pràctic i efectiu per superar la GUB. La teva preparació comença avui.",
        enabled: true,
        stock: false,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.Packs],
        price: 399.99,
        offer: 499.93,
        offer_text: "Estalvia diners amb els packs iOpos!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/519/image2"],
        banner: ["/519/image2"],
        link: "/tienda/libros/pack-gub-gold-2026",
        created_at: "2025-07-10 09:00:01",
        start_at: "2025-07-10 09:00:01",
        more_info: true,
        can_be_sent: true,
        items: 5,
        app: { modules: [96, 2, 6, 70], duration: 6 },
        pack: true,
        pack_items: [900, 899, 205],
        discount_not_applicable: true,
        note: "Pack GUB Gold (Temari + 1001 GUB + Psicos)",
        weight: 5581,
        shipping_price: 14.99,
    },
    // Pack GUB Imprescindibles (Psicos + Temari 2025/2026)
    {
        id: 520,
        tax: 0.04,
        sku: "iopos.book.pack.gub-imprescindible-2026",
        title: "Pack GUB Imprescindibles (Psicos + Temari) 2026",
        name: "Pack GUB Imprescindibles (Psicos + Temari) 2026",
        description: "Tot el que necessites per aprovar la teva oposició a la Guàrdia Urbana en un sol pack complet, actualitzat i enfocat a l'examen real.",
        enabled: true,
        stock: false,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.Packs],
        price: 159.99,
        offer: 189.98,
        offer_text: "Estalvia diners amb els packs iOpos!",
        shipment: 4.49,
        images: ["/520/image3"],
        banner: ["/520/image3"],
        link: "/tienda/libros/pack-gub-imprescindibles-psicos-temari-2026",
        created_at: "2025-07-09 00:00:00",
        start_at: "2025-07-09 00:00:00",
        more_info: true,
        can_be_sent: true,
        items: 4,
        pack: true,
        pack_items: [900, 205],
        discount_not_applicable: true,
        note: "Pack GUB Imprescindibles (Temari + Psicos)",
        weight: 4858,
        shipping_price: 14.99,
    },
    // Les 500 Preguntes per la Policia Municipal de Madrid 2025
    {
        id: 523,
        tax: 0.04,
        sku: "iopos.book.500-preguntas-pol-mun-madrid-2024",
        title: "Las 500 Preguntas para la Policía Municipal de Madrid 2025",
        name: "Las 500 Preguntas para la Policía Municipal de Madrid 2025",
        description: "Prepárate para la oposición a Policía Municipal de Madrid con 500 preguntas clave, explicaciones ampliadas y acceso gratuito a iPolicíaMadrid. Todo lo que necesitas para alcanzar tu objetivo, en un solo libro. ¡Da el primer paso hacia tu futuro!",
        enabled: true,
        stock: true,
        stock_message: "¡Disponible el 12 de noviembre!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.PMM],
        price: 19.99,
        // offer: 19.99,
        // offer_text: "¡Oferta lanzamiento solo las 100 primeras unidades!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/523/image2"],
        banner: ["/523/image2"],
        link: "/tienda/libros/500-preguntas-imprescindibles-policia-municipal-madrid-2024-2025/",
        created_at: "2025-06-30 00:00:10",
        start_at: "2025-06-30 00:00:10",
        more_info: true,
        can_be_sent: true,
        items: 1,
        limit: 500,
        app: { modules: [127], duration: 6 },
        weight: 352,
    },
    // Curs Policia Municipal de Sabadell 2025
    {
        id: 528,
        tax: 0.21,
        sku: "iopos.course.online.ref-2025-OPEN-QSA-curs-pol-mun-sabadell-2025",
        title: "Curs Policia Municipal de Sabadell 2025",
        name: "Curs Policia Municipal de Sabadell 2025",
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        description: "El camí cap a la Policia Municipal de Sabadell comença aquí: accés il·limitat, materials actualitzats i suport constant fins al dia de l'examen.",
        enabled: false,
        stock: false,
        stock_message: "Temporalment no disponible.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        offer: 89.99,
        offer_text: "Sprint final per a la convocatòria!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/528/image3"],
        banner: ["/528/image3"],
        link: "/tienda/cursos/curs-policia-municipal-sabadell-2025/",
        created_at: "2025-03-04 00:00:01",
        start_at: "2025-03-04 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 84, group_id: [1491] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Online en directe Dret Constitucional (Dissabte 9 març 16:00 h - 20:00 h)
    {
        id: 535,
        hidden: true,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        tax: 0.21,
        sku: "iopos.course.online-curs-dret-cons-zoom-ispc-marc-2024-alumnes",
        title: "Curs Online en directe Dret Constitucional (Dissabte 9 març 16:00 h - 20:00 h)",
        name: "Curs Online en directe Dret Constitucional (Dissabte 9 març 16:00 h - 20:00 h)",
        description: "Un curs intensiu en directe de 4 hores per reforçar Dret Constitucional amb enfocament 100% pràctic i orientat a examen, basat en el temari oficial de la 37a promoció. El repàs final imprescindible per arribar al dia de la prova amb els conceptes clars, seguretat i confiança, amb accés a la gravació fins a l’examen.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 34.99,
        //offer: 79.99,
        //recurrent: 'monthly',
        //offer_text: "¡Oferta curso primer mes!",
        shipment: 0.0,
        images: ["/532/image1"],
        banner: ["/532/image1"],
        link: "/tienda/cursos/curs-online-dret-constitucional-zoom-ispc-9-marc-2024-alumnes-iopos/",
        created_at: "2024-02-12 00:00:10",
        start_at: "2024-02-12 00:00:10",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 446, group_id: [1800] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Online en directe Drets Humans i Deontologia Professional (Diumenge 17 març 16:00 h - 20:00 h)
    {
        id: 537,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        hidden: true,
        tax: 0.21,
        sku: "iopos.course.online-curs-dret-humans-deont-zoom-ispc-17-marc-2024-alumnes",
        title: "Curs Online en directe Drets Humans i Deontologia Professional (Diumenge 17 març 16:00 h - 20:00 h)",
        name: "Curs Online en directe Drets Humans i Deontologia Professional (Diumenge 17 març 16:00 h - 20:00 h)",
        description: "Un curs intensiu en directe de 4 hores per reforçar Dret Administratiu amb un enfocament clar, pràctic i totalment orientat a l’examen, basat en el temari oficial de la 37a promoció. El repàs final que necessites per consolidar els conceptes clau i afrontar la prova amb màxima seguretat, amb accés a la gravació fins al dia de l’examen.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 34.99,
        // offer: 44.99,
        // recurrent: 'monthly',
        // offer_text: "¡Oferta curso primer mes!",
        shipment: 0.0,
        images: ["/533/image1"],
        banner: ["/533/image1"],
        link: "/tienda/cursos/curs-online-dret-humans-deontologia-pro-zoom-ispc-17-marc-2024-alumnes-iopos/",
        created_at: "2024-02-12 00:00:11",
        start_at: "2024-02-12 00:00:11",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 510, group_id: [1806] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Preparació Adequació Psicoprofessional Mossos d'Esquadra 2024 [Grup Extra]
    {
        id: 539,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Psicos],
        hidden: true,
        tax: 0.0,
        sku: "iopos.course.ref-2023-067-curs-prep-ade-psico-biodata-mossos-2024-grup-extra",
        title: "Curs Presencial Preparació Adequació Psicoprofessional Mossos d'Esquadra 2024 [Grup Extra]",
        name: "Curs Presencial Preparació Adequació Psicoprofessional Mossos d'Esquadra 2024 [Grup Extra]",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 89.99,
        //offer: 79.99,
        //recurrent: 'monthly',
        //offer_text: "¡Oferta curso primer mes!",
        shipment: 0.0,
        images: ["/505/b16"],
        banner: ["/505/b16"],
        link: "/tienda/cursos/curs-preparacio-tercera-prova-mossos-2024-extra/",
        created_at: "2024-01-13 00:00:01",
        start_at: "2024-01-13 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        evolmind: {
            course_id: 289,
            group_id: [1812],
            // limit: 30,
        },
        can_be_sent: false,
        items: 1,
    },
    // Simulacre d'Entrevista 2024 (1 hora) [Custom]
    {
        id: 541,
        tax: 0.21,
        hidden: true,
        category: [product_types_1.Category.Interviews],
        sku: "iopos.course.ref-2021-entrevista-personal-custom",
        title: "Simulacre d'Entrevista 2024 (1 hora) [Custom]",
        name: "Simulacre d'Entrevista 2024 (1 hora) [Custom]",
        description: "",
        enabled: false,
        stock: false,
        //special_buy:"/tienda/cursos/simulacre-dentrevista-2023-1h/#disponibles",
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/241/image2"],
        banner: ["/241/image2"],
        link: "/tienda/cursos/simulacre-dentrevista-2023-1h-custom/",
        created_at: "2024-02-13 00:00:01",
        start_at: "2024-02-13 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Preparació Entrevistes per Mossos d'Esquadra (1:30 h - Custom)
    {
        id: 542,
        hidden: true,
        tax: 0.21,
        sku: "iopos.course.classroom.prep-ent-mossos-1-30-2024-cust",
        title: "Preparació Entrevistes per Mossos d'Esquadra (1:30 h - Custom)",
        name: "Preparació Entrevistes per Mossos d'Esquadra (1:30 h - Custom)",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Sense estoc!",
        category: [product_types_1.Category.Interviews, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 89.99,
        // offer_text: "¡Last Call Mossos!",
        //recurrent: 'monthly',
        shipment: 0.0,
        images: ["/529/image1"],
        banner: ["/529/image1"],
        link: "/tienda/cursos/preparacio-entrevistes-mossos-2024-1-30h-custom/",
        created_at: "2024-02-13 00:00:10",
        start_at: "2024-02-13 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Simulacre Prèmium d'Entrevista 2025 (1:00 h - Comandament i Psicòleg)
    {
        id: 545,
        tax: 0.0,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.FASE4,
        ],
        sku: "iopos.course.ref-2025-simulacre-dentrevista-premium-2025-1h",
        title: "Simulacre Prèmium d'Entrevista 2025 (1:00 h - Comandament i Psicòleg)",
        name: "Simulacre Prèmium d'Entrevista 2025 (1:00 h - Comandament i Psicòleg)",
        description: "Posa't a prova amb un simulacre real d'entrevista amb comandament i psicòleg!",
        enabled: false,
        stock: false,
        special_buy: "/tienda/cursos/simulacre-dentrevista-premium-2025-1h/#disponibles",
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 189.99,
        shipment: 0.0,
        images: ["/545/image2"],
        banner: ["/545/image2"],
        link: "/tienda/cursos/simulacre-dentrevista-premium-2025-1h/",
        created_at: "2025-09-22 00:00:01",
        start_at: "2025-09-22 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 20 d'abril]
    {
        id: 548,
        category: [product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        tax: 0.21,
        hidden: true,
        sku: "iopos.course.online.ref-2022-103-curs-pers-apt-terrassa-20-abril-24",
        title: "Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 20 d'abril]",
        name: "Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 20 d'abril]",
        description: "Un curs presencial intensiu de 10 hores enfocat específicament a la Policia Municipal de Terrassa, on treballarem els conceptes clau amb explicacions detallades i estratègia d’examen. Inclou dossier esquematitzat, accés a campus online amb psicotècnics i simulacre final perquè arribis a la prova amb màxima preparació i confiança.",
        enabled: true,
        stock: false,
        stock_message: "Places esgotades!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        // offer: 189.99,
        // offer_text: "¡Pgit romo cursos presenciales y online",
        shipment: 0.0,
        images: ["/548/image1"],
        banner: ["/548/image1"],
        link: "/tienda/cursos/curs-personalitat-alumnes-terrassa-20-abril-2024/",
        created_at: "2024-03-19 00:00:02",
        start_at: "2024-03-19 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 404, group_id: [1832], limit: 30 },
    },
    // Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 21 d'abril]
    {
        id: 549,
        hidden: true,
        tax: 0.21,
        category: [product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        sku: "iopos.course.ref-2022-103-curs-pers-apt-terrassa-21-abril-24",
        title: "Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 21 d'abril]",
        name: "Curs Presencial Específic Policia Municipal de Terrassa 2024 [10 hores - 21 d'abril]",
        description: "Un curs presencial específic per preparar l’accés a la Policia Municipal de Terrassa 2024, amb 10 hores intensives centrades en els conceptes clau i l’estratègia d’examen. Inclou dossier esquematitzat, accés a campus online amb psicotècnics i simulacre final per arribar a la prova amb la màxima preparació.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        // offer: 189.99,
        // offer_text: "¡Pgit romo cursos presenciales y online",
        shipment: 0.0,
        images: ["/549/image1"],
        banner: ["/549/image1"],
        link: "/tienda/cursos/curs-personalitat-alumnes-terrassa-21-abril-2024/",
        created_at: "2024-03-19 00:00:02",
        start_at: "2024-03-19 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 404, group_id: [1835], limit: 30 },
    },
    // Simulacre/Preparació d'Entrevista Policial amb accés Campus 2025 (1:30 h)
    {
        id: 555,
        tax: 0.0,
        sku: "iopos.course.ref-2021-022-casos-practics-ent-pol-130",
        title: "Simulacre/Preparació d'Entrevista Policial amb accés Campus 2025 (1:30 h)",
        name: "Simulacre/Preparació d'Entrevista Policial amb accés Campus 2025 (1:30 h)",
        description: "Vols posar-te a prova amb una simulació / preparació d'entrevista policial amb role play?",
        special_buy: "/tienda/cursos/simulacre-preparacio-entrevista-policial-acces-campus-2025/#disponibles",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.Interviews, product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        stock_message: "No disponible.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        // recurrent: "monthly",
        price: 149.99,
        // offer: 149.99,
        // offer_text: "Oferta primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/555/image4"],
        banner: ["/555/image4"],
        link: "/tienda/cursos/simulacre-preparacio-entrevista-policial-acces-campus-2025/",
        created_at: "2025-04-03 00:00:00",
        start_at: "2025-04-03 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 78, group_id: [1887] },
    },
    // Preparació Entrevista Policial 2025 (1:30 h)
    {
        id: 556,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.prep-entrevista-policial-130-2025",
        title: "Preparació Entrevista Policial 2025 (1:30 h)",
        name: "Preparació Entrevista Policial 2025 (1:30 h)",
        description: "Destaquem el millor de tu per superar l'entrevista amb èxit.",
        enabled: false,
        stock: false,
        special_buy: "/tienda/cursos/preparacio-entrevista-policial-2025-130/#disponibles",
        stock_message: "No disponible.",
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.PL,
            product_types_1.Category.FASE2,
        ],
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/556/image4"],
        banner: ["/556/image4"],
        link: "/tienda/cursos/preparacio-entrevista-policial-2025-130/",
        created_at: "2025-09-21 00:00:01",
        start_at: "2025-09-21 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // 120 Casos d'Entrevista Policial
    {
        id: 561,
        tax: 0.04,
        created_at: "2025-09-23 00:00:08",
        start_at: "2025-09-23 00:00:08",
        sku: "iopos.book.120-casos-dentrevista-policial-3",
        name: "120 Casos d'Entrevista Policial",
        title: "120 Casos d'Entrevista Policial",
        description: "Prepara't per a les entrevistes policials amb 120 casos pràctics oficials. Aconsegueix la confiança i les eines necessàries per superar qualsevol repte!",
        enabled: true,
        stock: true,
        stock_message: "Estoc exhaurit!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.PL, product_types_1.Category.CP],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Últimes unitats!",
        // hidden: true,
        images: ["/561/image2"],
        banner: ["/561/image2"],
        shipment: 4.49,
        link: "/tienda/libros/120-casos-dentrevista-policial",
        more_info: true,
        can_be_sent: true,
        items: 1,
        limit: 200,
        low_stock_message: "¡Últimas unidades en stock!",
        weight: 872,
    },
    // Codi Penal i 4/2015 per a Terrassa 2024
    {
        id: 564,
        tax: 0.21,
        sku: "iopos.course.online-codi-penal-4-2015-terrassa-2024",
        title: "Codi Penal i 4/2015 per a Terrassa 2024",
        name: "Codi Penal i 4/2015 per a Terrassa 2024",
        description: " ",
        hidden: true,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 24.99,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/564/image1"],
        banner: ["/564/image1"],
        link: "/tienda/cursos/codi-penal-i-4-2015-terrassa-2024/",
        created_at: "2024-05-21 00:00:10",
        start_at: "2024-05-21 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 513, group_id: [1926] },
    },
    // Curs Online d'Orientació a l'ISPC 39ª Promoció (2025/26)
    {
        id: 572,
        tax: 0.21,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        sku: "iopos.course.online.open-orientacio-ispc-39-promocio-2025-26",
        title: "Curs Online d'Orientació a l'ISPC 39ª Promoció (2025/26)",
        name: "Curs Online d'Orientació a l'ISPC 39ª Promoció (2025/26)",
        description: "Avançat a la 39a promoció amb el curs més complet i actualitzat! Accedeix a tots els continguts necessaris des del primer moment i prepara't amb el millor material disponible.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 89.99,
        shipment: 0.0,
        images: ["/572/image1"],
        banner: ["/572/image1"],
        link: "/tienda/cursos/curs-online-orientacio-39-promocio-2025-26/",
        created_at: "2025-08-12 00:00:01",
        start_at: "2025-08-12 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 525, group_id: [2628] },
    },
    // Pack Físiques Sant Adrià del Besòs - CEM Besòs
    {
        id: 574,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria",
        title: "Pack Físiques Sant Adrià del Besòs - CEM Besòs",
        name: "Pack Físiques Sant Adrià del Besòs - CEM Besòs",
        description: "Assoleix el teu objectiu amb la nostra preparació intensiva per a proves físiques: entrenament personalitzat, resultats garantits!",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        discount_not_applicable: true,
        price: 14.99,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/574/image_h.jpg"],
        banner: ["/574/image_h.jpg"],
        link: "/tienda/cursos/pack-fisicas-sant-adria-2026/",
        created_at: "2025-07-25 00:00:10",
        start_at: "2025-07-25 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        childs: [575, 576, 577, 1274],
        hero: {
            firstTitle: "Pack Físiques Sant Adrià del Besòs",
            secondTitle: "Posa't en forma!",
            thirdTitle: "Assoleix el teu objectiu amb la nostra **preparació intensiva** per a **proves físiques**: **entrenament personalitzat**, **resultats garantits**!",
            landscape: "/574/hero_h.jpg",
            portrait: "/574/hero_v.jpg",
        },
    },
    // Pack Físiques Sant Adrià del Besòs - 1 Classe
    {
        id: 575,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-1-clase",
        title: "Pack Físiques Sant Adrià del Besòs - 1 Classe",
        name: "Pack Físiques Sant Adrià del Besòs - 1 Classe",
        short: "Pack 1 Classe",
        description: "Perfecte per començar: un pack de físiques amb 1 classe ideal per a opositors que busquen una introducció sòlida.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 19.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/574/image5"],
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        parent: 574,
        calendly: {
            uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c",
            // uuid: "0fd6cf4b-d9eb-4209-a9d0-3264391e17fa",
            units: 1,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Sant Adrià del Besòs - 4 Classes
    {
        id: 576,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-4-clases",
        title: "Pack Físiques Sant Adrià del Besòs - 4 Classes",
        name: "Pack Físiques Sant Adrià del Besòs - 4 Classes",
        short: "Pack 4 Classes",
        description: "Potencia la teva preparació: un pack de físiques amb 4 classes dissenyades per a opositors compromesos a millorar el seu rendiment.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 59.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/574/image5"],
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 4,
        parent: 574,
        calendly: {
            uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", // production
            // uuid: "0fd6cf4b-d9eb-4209-a9d0-3264391e17fa", // dev
            units: 4,
        },
        default_in_parent: true,
        disallow_multiple_units: true,
    },
    // Pack Físiques Sant Adrià del Besòs - 8 Classes
    {
        id: 577,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-8-clases",
        title: "Pack Físiques Sant Adrià del Besòs - 8 Classes",
        name: "Pack Físiques Sant Adrià del Besòs - 8 Classes",
        short: "Pack 8 Classes",
        description: "Potencia la teva preparació: un pack de físiques amb 8 classes dissenyades per a opositors compromesos a millorar el seu rendiment.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "Maximiza tus oportunidades: un pack de físicas con 5 clases que te ofrece una formación más completa y efectiva.",
        price: 89.99,
        discount_not_applicable: true,
        // price_text: "Gaudeix d'un 20 % de descompte",
        shipment: 0.0,
        images: ["/574/image5"],
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 8,
        parent: 574,
        calendly: {
            uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", // prod
            // uuid: "0fd6cf4b-d9eb-4209-a9d0-3264391e17fa", // dev
            units: 8,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Sant Adrià del Besòs - 10 Classes
    {
        id: 578,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-10-clases",
        title: "Pack Físiques Sant Adrià del Besòs - 10 Classes",
        name: "Pack Físiques Sant Adrià del Besòs - 10 Classes",
        short: "Pack 10 Clases",
        description: "El teu èxit assegurat: un pack de físiques amb 10 classes, l'opció més completa per a opositors que volen dominar totes les àrees.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 139.99,
        discount_not_applicable: true,
        price_text: "Gaudeix d'un 30 % de descompte",
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/574/image2"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 10,
        parent: 574,
        calendly: {
            uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", // prod
            // uuid: "0fd6cf4b-d9eb-4209-a9d0-3264391e17fa", // dev
            units: 10,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Torredembarra - Apolo
    {
        id: 579,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo",
        title: "Pack Físiques Torredembarra - Apolo",
        name: "Pack Físiques Torredembarra - Apolo",
        description: "Converteix-te en el millor amb el nostre entrenament intensiu: velocitat, força i resistència al màxim nivell!",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible temporalment.",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 19.99,
        discount_not_applicable: true,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/579/image_h.jpg"],
        banner: ["/579/image_h.jpg"],
        link: "/tienda/cursos/pack-fisicas-torredembarra-apolo-2025-2026/",
        created_at: "2025-07-25 00:00:10",
        start_at: "2025-07-25 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        childs: [580, 581, 582, 1309],
        hero: {
            firstTitle: "Pack Físiques Torredembarra - Apolo",
            secondTitle: "Posa't en forma!",
            thirdTitle: "Converteix-te en el millor amb el nostre entrenament intensiu: velocitat, força i resistència al màxim nivell!",
            landscape: "/579/hero_h.jpg",
            portrait: "/579/hero_v.jpg",
        },
    },
    // Pack Físiques Torredembarra Apolo - 1 Classe
    {
        id: 580,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo-1-clase",
        title: "Pack Físiques Torredembarra Apolo - 1 Classe",
        name: "Pack Físiques Torredembarra Apolo - 1 Classe",
        short: "Pack 1 Classe",
        description: "Perfecto para empezar: un pack de físicas con 1 clase ideal para opositores que buscan una introducción sólida.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 19.99,
        discount_not_applicable: true,
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/579/image4"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        parent: 579,
        calendly: {
            uuid: "a07ad2ef-98f7-4145-9dc7-14fb6cbe2de5", // prod
            // uuid: "df603638-ce27-4518-b1fe-b9b63e23c806", // dev
            units: 1,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Torredembarra Apolo - 4 Classes
    {
        id: 581,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo-4-clases",
        title: "Pack Físiques Torredembarra Apolo - 4 Classes",
        name: "Pack Físiques Torredembarra Apolo - 4 Classes",
        short: "Pack 4 Classes",
        description: "Potencia tu preparación: un pack de físicas con 4 clases diseñadas para opositores comprometidos a mejorar su rendimiento.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 59.99,
        discount_not_applicable: true,
        // price_text: "Gaudeix d'un 10 % de descompte",
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/579/image4"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 4,
        parent: 579,
        calendly: {
            uuid: "a07ad2ef-98f7-4145-9dc7-14fb6cbe2de5", // prod
            // uuid: "df603638-ce27-4518-b1fe-b9b63e23c806", // dev
            units: 4,
        },
        disallow_multiple_units: true,
        default_in_parent: true,
    },
    // Pack Físiques Torredembarra Apolo - 8 Classes
    {
        id: 582,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo-8-clases",
        title: "Pack Físiques Torredembarra Apolo - 8 Classes",
        name: "Pack Físiques Torredembarra Apolo - 8 Classes",
        short: "Pack 8 Classes",
        description: "Maximiza tus oportunidades: un pack de físicas con 8 clases que te ofrece una formación más completa y efectiva.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 89.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/579/image4"],
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 8,
        parent: 579,
        default_in_parent: false,
        calendly: {
            uuid: "a07ad2ef-98f7-4145-9dc7-14fb6cbe2de5", // prod
            // uuid: "df603638-ce27-4518-b1fe-b9b63e23c806", // dev
            units: 8,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Torredembarra Apolo - 10 Classes
    {
        id: 583,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo-10-clases",
        title: "Pack Físiques Torredembarra Apolo - 10 Classes",
        name: "Pack Físiques Torredembarra Apolo - 10 Classes",
        short: "Pack 10 Classes",
        description: "Tu éxito asegurado: un pack de físicas con 10 clases, la opción más completa para opositores que quieren dominar todas las áreas",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 139.99,
        discount_not_applicable: true,
        price_text: "Gaudeix d'un 30 % de descompte",
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/579/image1"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 10,
        parent: 579,
        calendly: {
            uuid: "038711ed-b1a2-406a-b4b5-2fbafdeebc3f", // prod
            // uuid: "df603638-ce27-4518-b1fe-b9b63e23c806", // dev
            units: 10,
        },
        disallow_multiple_units: true,
    },
    // Pack Físiques Sant Cugat - Crossfit Lynx
    {
        id: 585,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-cugat-lynx",
        title: "Pack Físiques Sant Cugat - Crossfit Lynx",
        name: "Pack Físiques Sant Cugat - Crossfit Lynx",
        description: "Entrena amb els millors per assolir el teu màxim rendiment: preparació personalitzada i resultats excel·lents!",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        price: 19.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/585/image5"],
        banner: ["/585/image5"],
        link: "/tienda/cursos/pack-fisicas-sant-cugat-crossift-lynx-2026/",
        created_at: "2025-07-25 00:00:10",
        start_at: "2025-07-25 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        childs: [586, 587, 588],
    },
    // Pack Físiques Sant Cugat CrossFit Lynx - 1 Classe
    {
        id: 586,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-santcugat-crossfitlynx-1-clase",
        title: "Pack Físicas Sant Cugat CrossFit Lynx - 1 Clases",
        name: "Pack Físicas Sant Cugat CrossFit Lynx - 1 Clases",
        short: "Pack 1 Clase",
        description: "Perfecto para empezar: un pack de físicas con 1 clase ideal para opositores que buscan una introducción sólida.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 19.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/585/image5"],
        created_at: "2025-06-28 00:00:10",
        start_at: "2025-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        parent: 585,
        calendly: {
            uuid: "4e50c3a7-62e3-4a17-8a44-e51a1ba11b9e", // prod
            // uuid: "72656b9d-6af4-4164-9a15-d58cba5d8d13", // dev
            units: 1,
        },
    },
    // Pack Físiques Sant Cugat CrossFit Lynx - 4 Classes
    {
        id: 587,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-santcugat-crossfitlynx-4-clases",
        title: "Pack Físicas Sant Cugat CrossFit Lynx - 4 Clases",
        name: "Pack Físicas Sant Cugat CrossFit Lynx - 4 Clases",
        short: "Pack 4 Clases",
        description: "Potencia tu preparación: un pack de físicas con 4 clases diseñadas para opositores comprometidos a mejorar su rendimiento.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        discount_not_applicable: true,
        price: 59.99,
        shipment: 0.0,
        images: ["/585/image5"],
        created_at: "2025-06-28 00:00:10",
        start_at: "2025-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 4,
        default_in_parent: true,
        parent: 585,
        calendly: {
            uuid: "4e50c3a7-62e3-4a17-8a44-e51a1ba11b9e", // prod
            // uuid: "72656b9d-6af4-4164-9a15-d58cba5d8d13", // dev
            units: 4,
        },
    },
    // Pack Físiques Sant Cugat CrossFit Lynx - 8 Classes
    {
        id: 588,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-santcugat-crossfitlynx-8-clase",
        title: "Pack Físiques Sant Cugat CrossFit Lynx - 8 Classes",
        name: "Pack Físiques Sant Cugat CrossFit Lynx - 8 Classes",
        short: "Pack 8 Classes",
        description: "Maximiza tus oportunidades: un pack de físicas con 8 clases que te ofrece una formación más completa y efectiva.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        discount_not_applicable: true,
        price: 89.99,
        // price_text: "Gaudeix d'un 20 % de descompte",
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/585/image5"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 8,
        parent: 585,
        default_in_parent: true,
        calendly: {
            uuid: "4e50c3a7-62e3-4a17-8a44-e51a1ba11b9e", // prod
            // uuid: "72656b9d-6af4-4164-9a15-d58cba5d8d13", // dev
            units: 8,
        },
    },
    // Pack Físiques Sant Cugat CrossFit Lynx - 10 Classes
    {
        id: 589,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-santcugat-crossfitlynx-10-clase",
        title: "Pack Físiques Sant Cugat CrossFit Lynx - 10 Classes",
        name: "Pack Físiques Sant Cugat CrossFit Lynx - 10 Classes",
        short: "Pack 10 Classes",
        description: "Tu éxito asegurado: un pack de físicas con 10 clases, la opción más completa para opositores que quieren dominar todas las áreas.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "",
        price: 139.99,
        discount_not_applicable: true,
        price_text: "Gaudeix d'un 30 % de descompte",
        // offer: 59.99,
        // offer_text: "¡Promo cursos presenciales y online",
        shipment: 0.0,
        images: ["/585/image1"],
        // banner: ["/574/image1"],
        // link: "/tienda/cursos/pack-fisicas-sant-adria/",
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 10,
        parent: 585,
        calendly: {
            uuid: "4e50c3a7-62e3-4a17-8a44-e51a1ba11b9e", // prod
            // uuid: "72656b9d-6af4-4164-9a15-d58cba5d8d13", // dev
            units: 10,
        },
    },
    // Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes 8:00 - 14 h, Octubre i Novembre)
    {
        id: 590,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "iopos.course.f2f.2024-open-me-curs-presencial-mossos-24-25-m3",
        title: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes 8:00 - 14 h, Octubre i Novembre)",
        name: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes 8:00 - 14 h, Octubre i Novembre)",
        description: "Reserva la teva plaça per al curs intensiu de Mossos d'Esquadra, dissabtes d'oct. i nov. de 8:00 a 14:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        // offer: 189.99,
        // offer_text: "¡Pgit romo cursos presenciales y online",
        shipment: 0.0,
        images: ["/590/image3"],
        banner: ["/590/image3"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m3-dissabtes/",
        created_at: "2024-07-26 00:00:01",
        start_at: "2024-07-26 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 29,
        evolmind: { course_id: 349, group_id: [1944] },
    },
    // Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M4] (Diumenges 8:00 - 14 h, Octubre i Novembre)
    {
        id: 591,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2024-open-me-curs-presencial-mossos-24-25-m4",
        title: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M4] (Diumenges 8:00 - 14 h, Octubre i Novembre)",
        name: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M4] (Diumenges 8:00 - 14 h, Octubre i Novembre)",
        description: "Reserva la teva plaça per al curs intensiu de Mossos d'Esquadra, diumenges d'oct. i nov. de 8:00 a 14:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        // offer: 189.99,
        // offer_text: "¡Pgit romo cursos presenciales y online",
        shipment: 0.0,
        images: ["/591/image3"],
        banner: ["/591/image3"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m4-diumenges/",
        created_at: "2024-07-26 00:00:01",
        start_at: "2024-07-26 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 28,
        evolmind: { course_id: 349, group_id: [1947] },
    },
    // Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M1] (Dimarts 16:00 - 21 h, Setembre, Octubre i Novembre)
    {
        id: 594,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2025-open-me-curs-presencial-mossos-24-25-m1-40h",
        title: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M1] (Dimarts 16:00 - 21 h, Setembre, Octubre i Novembre)",
        name: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M1] (Dimarts 16:00 - 21 h, Setembre, Octubre i Novembre)",
        description: "Reserva la teva plaça per al curs intensiu Mossos d'Esquadra (40 hores), dimarts de set, oct. i nov. de 16:00 a 21:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 349.99,
        // offer: 349.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/594/image1"],
        banner: ["/594/image1"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m1-40h/",
        created_at: "2024-07-29 00:00:01",
        start_at: "2024-07-29 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [1956] },
    },
    // Curs Presencial Codi Penal y LO 4/2015 (28 setembre - Grup M1)
    {
        id: 595,
        tax: 0.0,
        sku: "iopos.course.ref-2024-curs-presencial-cp-4-2015-28-set-m1",
        title: "Curs Presencial Codi Penal y LO 4/2015 (28 setembre - Grup M1)",
        name: "Curs Presencial Codi Penal y LO 4/2015 (28 setembre - Grup M1)",
        description: "¡Preparat per destacar en la teva oposició amb el nostre Curs Intensiu de Codi Penal i L.O. 4/2015!",
        enabled: false,
        category: [product_types_1.Category.ISPC, product_types_1.Category.FaceToFace],
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 59.99,
        // offer: 34.99,
        // offer_text: "¡Black Friday en iOpos!",
        shipment: 0.0,
        link: "/tienda/cursos/curs-presencial-codi-penal-4-2015-28-setembre-m1/",
        images: ["/595/image2"],
        banner: ["/595/image2"],
        created_at: "2024-08-03 00:00:02",
        start_at: "2024-08-03 00:00:02",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 24,
        evolmind: { course_id: 411, group_id: [1962] },
    },
    // Curs Presencial Codi Penal i LO 4/2015 (5 octubre - Grup M2)
    {
        id: 596,
        tax: 0.0,
        sku: "iopos.course.ref-2024-curs-presencial-cp-4-2015-5-oct-m2",
        title: "Curs Presencial Codi Penal i LO 4/2015 (5 octubre - Grup M2)",
        name: "Curs Presencial Codi Penal i LO 4/2015 (5 octubre - Grup M2)",
        description: "¡Preparat per destacar en la teva oposició amb el nostre Curs Intensiu de Codi Penal i L.O. 4/2015!",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.ISPC, product_types_1.Category.FaceToFace],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 59.99,
        // offer: 34.99,
        // offer_text: "¡Black Friday en iOpos!",
        shipment: 0.0,
        link: "/tienda/cursos/curs-presencial-codi-penal-4-2015-5-octubre-m2/",
        images: ["/595/image2"],
        banner: ["/595/image2"],
        created_at: "2024-08-04 00:00:02",
        start_at: "2024-08-04 00:00:02",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 411, group_id: [1965] },
    },
    // Curs Online per la Guàrdia Urbana de Reus 2025 (Accés fins dia examen)
    {
        id: 597,
        tax: 0.21,
        sku: "iopos.course.online-2024-open-reus-curs-guardia-urbana-reus-2025",
        title: "Curs Online per la Guàrdia Urbana de Reus 2025 (Accés fins dia examen)",
        name: "Curs Online per la Guàrdia Urbana de Reus 2025 (Accés fins dia examen)",
        description: "Prepara't per a la Guàrdia Urbana de Reus 2025 amb un curs complet i actualitzat. Accés fins al dia de l'examen. Inscriu-te ara!",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 89.99,
        // offer: 89.99,
        // offer_text: "Promoció les 10 primeres matrícules!",
        // offer: 29.99,
        // offer_text: "",
        shipment: 0.0,
        images: ["/597/image5"],
        banner: ["/597/image5"],
        link: "/tienda/cursos/curs-online-guardia-urbana-reus-2025/",
        created_at: "2025-06-22 00:00:01",
        start_at: "2025-06-22 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 42, group_id: [2604] },
        can_be_sent: false,
        items: 1,
    },
    // Proves Psicotècniques Online per Mossos, GuB i Policia Local 2025 (10 hores amb vídeos explicatius)
    {
        id: 598,
        tax: 0.21,
        sku: "iopos.course.ref-2022-103-curs-personalitat-i-apt-2024-10-hores",
        title: "Proves Psicotècniques Online per Mossos, GuB i Policia Local 2026 (10 hores amb vídeos explicatius)",
        name: "Proves Psicotècniques Online per Mossos, GuB i Policia Local 2026 (10 hores amb vídeos explicatius)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        description: "El curs més complet de Catalunya per dominar els psicotècnics psicoprofessionals i aptitudinals de les oposicions a Policies Locals, Guàrdia Urbana i Mossos d’Esquadra. Amb material oficial, vídeos detallats i simulacres reals, tindràs tot el que necessites per superar les proves amb seguretat i marcar la diferència el dia clau.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 79.99,
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/598/image2"],
        banner: ["/598/image2"],
        link: "/tienda/cursos/proves-psicotecniques-online-mossos-gub-pl-10h-videos-2025/",
        created_at: "2025-06-08 00:00:01",
        start_at: "2025-06-08 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 404, group_id: [1968] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h)
    {
        id: 599,
        tax: 0.21,
        sku: "iopos.course.ref-curs-online-zoom-introduccio-oac-31-agost",
        title: "Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h)",
        name: "Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h)",
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        description: "Aprèn les bases de l'OAC en aquest curs online interactiu, impartit en directe per Zoom. Apunta't i domina els conceptes clau en només un matí!",
        enabled: false,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 59.99,
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/599/image1"],
        banner: ["/599/image1"],
        link: "/tienda/cursos/curs-directe-zoom-introduccio-oac-31-agost/",
        created_at: "2024-08-12 00:00:01",
        start_at: "2024-08-12 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 534, group_id: [1974] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h) Alumnes
    {
        hidden: true,
        id: 600,
        tax: 0.21,
        sku: "iopos.course.ref-curs-online-zoom-introduccio-oac-31-agost-alumnes",
        title: "Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h)",
        name: "Curs Online en directe d'Introducció a l'OAC (en directe per Zoom - 31 ago. 09:00 - 14:00 h)",
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        description: "Aprèn les bases de l'OAC en aquest curs online interactiu, impartit en directe per Zoom. Apunta't i domina els conceptes clau en només un matí!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/599/image1"],
        banner: ["/599/image1"],
        link: "/tienda/cursos/curs-directe-zoom-introduccio-oac-31-agost-alumnes/",
        created_at: "2024-08-12 00:00:01",
        start_at: "2024-08-12 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 534, group_id: [1974] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (12 octubre)
    {
        id: 601,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.psicos-aptitudinals-gub-2024-12-oct",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (12 octubre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (12 octubre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 12 d'doctubre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/601/image3"],
        banner: ["/601/image3"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-12-octubre/",
        created_at: "2024-08-30 00:00:00",
        start_at: "2024-08-30 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 6,
        evolmind: { course_id: 355, group_id: [1977] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M7] (Dis-Diu 15:30 - 20:30 h, Set, Oct i Nov)
    {
        id: 602,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2025-open-me-curs-presencial-mossos-24-25-m7",
        title: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M7] (Dis-Diu 15:30 - 20:30 h, Set, Oct i Nov)",
        name: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M7] (Dis-Diu 15:30 - 20:30 h, Set, Oct i Nov)",
        description: "Reserva la teva plaça per al curs intensiu Mossos d'Esquadra, dissabtes i diumenges de set, oct. i novembre de 15:30 h a 20:30h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/602/image1"],
        banner: ["/602/image1"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m7-dis-diu/",
        created_at: "2024-09-02 00:00:01",
        start_at: "2024-09-02 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [1980] },
    },
    // Formació en Seguretat Ciutadana Bàsica pels agents interins de Catalunya (4a edició - 5 d'abril)
    {
        id: 603,
        tax: 0.0,
        category: [product_types_1.Category.Atlantic, product_types_1.Category.FaceToFace],
        sku: "iopos.course.f2f.formacio-seguretat-ciutadana-2025-5-abril",
        title: "Formació en Seguretat Ciutadana Bàsica pels agents interins de Catalunya (4a edició - 5 d'abril)",
        name: "Formació en Seguretat Ciutadana Bàsica pels agents interins de Catalunya (4a edició - 5 d'abril)",
        description: "Prepara't per destacar en la teva carrera policial amb el nostre curs especialitzat per agents interins de Policies Locals i Guàrdies Urbanes.",
        enabled: true,
        stock: false,
        stock_message: "Properament nova data!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 44.99,
        shipment: 0.0,
        images: ["/603/image2"],
        banner: ["/603/image2"],
        link: "/tienda/atlantic/cursos/formacio-seguretat-ciutadana-basica-agents-interins-catalunya-2025-5-dabril/",
        created_at: "2025-02-07 00:00:01",
        start_at: "2025-02-07 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 25,
    },
    // Curs Bastó Policial Extensible amb Certificat Homologat (16 novembre 08:30 h - 13:30 h)
    {
        id: 604,
        tax: 0.0,
        category: [product_types_1.Category.Atlantic, product_types_1.Category.FaceToFace],
        sku: "2024-curs-presencial-basto-policial-extensible-certificat-homologat-16-nov",
        title: "Curs Bastó Policial Extensible amb Certificat Homologat (16 novembre 08:30 h - 13:30 h)",
        name: "Curs Bastó Policial Extensible amb Certificat Homologat (16 novembre 08:30 h - 13:30 h)",
        description: "Aprèn l'ús legal i efectiu d'aquesta eina essencial, desenvolupa tècniques avançades i aplica-les amb responsabilitat. Inscriu-te ara i eleva la teva preparació al màxim!",
        enabled: true,
        stock: false,
        stock_message: "Properament nova data!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 59.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/604/image2"],
        banner: ["/604/image2"],
        link: "/tienda/atlantic/cursos/formacio-us-basto-policial-extensible-novembre/",
        created_at: "2024-09-04 00:00:01",
        start_at: "2024-09-04 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 20,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (20 octubre)
    {
        id: 605,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-20-oct",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (20 octubre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (20 octubre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 20 d'doctubre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/605/image1"],
        banner: ["/605/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-20-octubre/",
        created_at: "2024-09-04 00:00:00",
        start_at: "2024-09-04 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [1983] },
        can_be_sent: false,
        items: 1,
    },
    // Curs de Psicotècnics en directe (12 h a través de Zoom - Octubre 2024)
    {
        id: 606,
        tax: 0.21,
        sku: "iopos.course.classroom.ref-2023-006-psicos-en-directe-zoom-12-hores-oct-2024",
        title: "Curs de Psicotècnics en directe (12 h a través de Zoom - Octubre 2024)",
        name: "Curs de Psicotècnics en directe (12 h a través de Zoom - Octubre 2024)",
        description: "Transforma el teu futur amb el nostre curs intensiu de psicos: 12 hores de formació en directe, exercicis nous i tot el suport que necessites per dominar la prova i garantir el teu èxit.",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "Últims dies per a l'oposició",
        shipment: 0.0,
        images: ["/606/image1"],
        banner: ["/606/image1"],
        link: "/tienda/cursos/curs-psicotecnics-en-directe-zoom-12-hores-zoom-octubre-2024/",
        created_at: "2024-09-06 00:00:02",
        start_at: "2024-09-06 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 72, group_id: [1989] },
        can_be_sent: false,
        items: 1,
    },
];
exports.default = products;
